import { DataItemService } from '../common/data/data-item.service';
import * as i0 from "@angular/core";
import * as i1 from "../common/auth/auth-api-http-client";
import * as i2 from "@angular/router";
export class IpWhiteListItemService extends DataItemService {
    constructor(httpClient, route) {
        super({
            httpClient,
            url: 'auth/ipwhitelist/item'
        });
        this.hospitalList = this.httpClient.get('health/cradles/customerCodes');
    }
}
IpWhiteListItemService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function IpWhiteListItemService_Factory() { return new IpWhiteListItemService(i0.ɵɵinject(i1.AuthApiHttpClient), i0.ɵɵinject(i2.ActivatedRoute)); }, token: IpWhiteListItemService, providedIn: "root" });
